import React from 'react';
import {connect} from 'react-redux';
import Section from './Section';
import MenuItem from './MenuItem';
import createItems from './items/createItems';
import listItems from './items/listItems';
import analyticsItems from './items/analyticsItems';
import {sidebar} from './items/profileItems';
import * as roles from '../../services/access/roles';
import * as subscriptionTypes from '../company/subscriptionType';
import * as rolesUtils from '../../services/access/utils';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import superAdmnItems from "./items/superAdmnItems";

class Navigation extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            lastClickedItem: '',
            activeNavs: {
                opret: false,
                lists: false,
                profil: false,
                analytics: false,
                superAdmin: false
            },
        };

        let activeItems = this.getActiveItemsByPath();
        if (activeItems.parentTabId) {
            this.state.activeNavs[activeItems.parentTabId] = true;
        }
        this.state.lastClickedItem = activeItems.subItemId;

        this.itemClicked = this.itemClicked.bind(this);
        this.onTabClick = this.onTabClick.bind(this);
        this.onTitleClick = this.onTitleClick.bind(this);
        this.onIconClick = this.onIconClick.bind(this);
    }

    matchesCurrentPath(item) {
        return item.to == window.location.href.split('#').pop();
    }

    getActiveItemsByPath() {
        let subItem;
        let parentTabId;

        subItem = createItems.find(this.matchesCurrentPath);

        if (subItem) {
            parentTabId = 'opret';
        } else {
            subItem = listItems.find(this.matchesCurrentPath);
            if (subItem) {
                parentTabId = 'lists';
            } else {
                subItem = analyticsItems.find(this.matchesCurrentPath);
                if (subItem) {
                    parentTabId = 'analytics';
                } else {
                    subItem = sidebar.find(this.matchesCurrentPath);

                    if (subItem) {
                        parentTabId = 'profil';
                    } else {
                        if(subItem) {
                            parentTabId = 'superAdmin'
                        }
                    }

                }
            }
        }

        return {
            subItemId: (subItem) ? subItem.id : false,
            parentTabId: (parentTabId) ? parentTabId : false
        };
    }

    toggleTab(elementId) {

        let currentState = this.state.activeNavs[elementId];

        if (currentState !== undefined) {
            this.state.activeNavs = {
                opret: false,
                lists: false,
                profil: false,
                analytics: false,
                superAdmin: false,
            };
            this.state.activeNavs[elementId] = !currentState;

            this.setState({
                activeNavs: this.state.activeNavs,
            })
        }
    }

    onTabClick(elementId) {
        if (elementId != undefined) {
            this.toggleTab(elementId);
        }
    }

    onTitleClick(elementId) {
        if (elementId != undefined) {
            this.toggleTab(elementId);
        }
    }

    onIconClick(elementId) {
        if (elementId != undefined) {
            this.toggleTab(elementId);
        }
    }

    itemClicked(itemId) {
        this.setState({lastClickedItem: itemId});
    }

    /**
     * Get formatted array of MenuItem components from array of data
     **/
    getMenuItems(menuItems) {
        // filtrate items according to roles
        menuItems = menuItems.filter((item) => {
            if (!item.roles) {
                return true;
            }

            if ((item.id == 'maskiner-list' || item.id == 'maskine')
                && this.props.user.company.portalId === 4) {
                return false;
            }
            return rolesUtils.rolesHasAccess(this.props.roles, item.roles)
                && rolesUtils.subscriptionTypeHasAccess(this.props, item.subscriptionTypes);
        });


        return menuItems.map((item, key) => {
            return <MenuItem
                key={key}
                id={item.id}
                to={item.to}
                title={item.title}
                itemClicked={this.itemClicked.bind(this)}
                active={this.state.lastClickedItem == item.id}
            />
        });
    }

    render() {
        return (
            <div>
                <div id="sidebar-menu">
                    <ul>
                        {
                            (rolesUtils.rolesHasAccess(this.props.roles, [roles.PARTNER_ROLE])
                            /*&& rolesUtils.isNotSubscriptionType(this.props.user, subscriptionTypes.MASKINSTATIONER_MINI)*/) ?
                                <Section
                                    id="opret"
                                    iconClassName="mdi mdi-buffer"
                                    title={this.props.intl.formatMessage(messages.sideBarCreateMenuTitle)}
                                    onTabClick={this.onTabClick}
                                    onTitleClick={this.onTitleClick}
                                    onIconClick={this.onIconClick}
                                    active={this.state.activeNavs['opret']}
                                >
                                    {this.getMenuItems(createItems)}
                                </Section>
                                : null
                        }
                        {
                            (rolesUtils.rolesHasAccess(this.props.roles, [roles.PARTNER_ROLE])
                            /*&& rolesUtils.isNotSubscriptionType(this.props.user, subscriptionTypes.MASKINSTATIONER_MINI)*/) ?
                                <Section
                                    id="lists"
                                    iconClassName="mdi mdi-format-list-bulleted-type"
                                    title={this.props.intl.formatMessage(messages.sideBarListMenuTitle)}
                                    onTabClick={this.onTabClick}
                                    onTitleClick={this.onTitleClick}
                                    onIconClick={this.onIconClick}
                                    active={this.state.activeNavs['lists']}
                                >
                                    {this.getMenuItems(listItems)}
                                </Section>
                                : null
                        }
                        {
                            rolesUtils.rolesHasAccess(this.props.roles,[roles.PARTNER_ROLE, roles.FBG_WEBMASTER]) ?
                                <Section
                                    id="profil"
                                    iconClassName="mdi mdi-settings"
                                    title={this.props.intl.formatMessage(messages.sideBarProfileMenuItemTitle)}
                                    onTabClick={this.onTabClick}
                                    onTitleClick={this.onTitleClick}
                                    onIconClick={this.onIconClick}
                                    active={this.state.activeNavs['profil']}
                                >
                                    {this.getMenuItems(sidebar)}
                                </Section>
                                : null
                        }
                        {
                            rolesUtils.rolesHasAccess(this.props.roles, [roles.PARTNER_ROLE, roles.FBG_WEBMASTER]) ?
                                <Section
                                    id="analytics"
                                    iconClassName="mdi mdi-chart-line"
                                    title="Statistik"
                                    onTabClick={this.onTabClick}
                                    onTitleClick={this.onTitleClick}
                                    onIconClick={this.onIconClick}
                                    active={this.state.activeNavs['analytics']}
                                >
                                    {this.getMenuItems(analyticsItems)}
                                </Section>
                                : null
                        }
                        {
                            rolesUtils.rolesHasAccess(this.props.roles, [roles.SUPER_ADMINISTRATOR]) ?
                                <Section
                                    id="superAdmin"
                                    iconClassName="mdi mdi-account-star"
                                    title="Super admin"
                                    onTabClick={this.onTabClick}
                                    onTitleClick={this.onTitleClick}
                                    onIconClick={this.onIconClick}
                                    active={this.state.activeNavs['superAdmin']}
                                >
                                    {this.getMenuItems(superAdmnItems)}
                                </Section>
                                : null
                        }
                    </ul>
                </div>
            </div>
        );
    };
}

function mapStateToProps(state, ownProps) {
    return {
        roles: state.user.roles,
        user: state.user
    };
}

export default injectIntl(connect(mapStateToProps)(Navigation));



// WEBPACK FOOTER //
// ./web/src/components/navigation/Navigation.jsx